import defaultEnUSTranslations from '../locales/en-US.json'
import defaultEnGBTranslations from '../locales/en-GB.json'
import defaultEnAUTranslations from '../locales/en-AU.json'
import defaultUkUaTranslations from '../locales/uk-UA.json'

import VueI18n from 'vue-i18n'
import store from "@/store";
import { languages } from "@/consts/languages";
import Vue from 'vue';
import { defaultFacilityValues } from "@/consts/defaultFacilityValues";

Vue.use(VueI18n);

const facilityLanguageIso = store?.state?.facilityModule?.selectedFacility?.languageIso || ''
const locale =  facilityLanguageIso.length && languages.some(x=>x.code === facilityLanguageIso)? facilityLanguageIso: defaultFacilityValues.locale

const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: locale,
    messages: { 
        ['en-US']: defaultEnUSTranslations,
        ['en-GB']: defaultEnGBTranslations,
        ['en-AU']: defaultEnAUTranslations,
        ['uk-UA']: defaultUkUaTranslations
    }
});

export default i18n;